import React from 'react';
import { StarIcon } from 'lucide-react';
export function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-0.5 ${className}`} aria-label="5 de 5 estrellas" data-id="element-156">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[#F5C518] text-[#F5C518]" data-id="element-157" />)}
    </div>;
}